query dac7BlocksForUser {
  dac7BlocksForUser {
    sellingServiceBlock
    payoutBlock
  }
}
